import { type FC, type ReactNode } from 'react'
import { useIntl } from 'react-intl'

import {
  type OfferV11,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { ProductSellerPromotionInfoBannerHarmonisation } from '../../ProductSellerPromotionInfoBanner/ProductSellerPromotionInfoBannerHarmonisation'

export const ProductBuyBoxSellerPromotionModal: FC<{
  dialogTitle: ReactNode
  isOpen: boolean
  offer: OfferV11
  onClose: () => void
  product: PimProductWithVariantsV1
}> = ({ dialogTitle, isOpen, offer, onClose, product }) => {
  const intl = useIntl()

  return (
    <Dialog onClose={onClose} open={isOpen}>
      <DialogTitle
        onClose={onClose}
        slotProps={{
          closeButton: {
            'aria-label': intl.formatMessage({
              id: 'general.link.label.close',
            }),
          },
        }}
      >
        {dialogTitle}
      </DialogTitle>
      <DialogContent>
        <div
          // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
          className="max-w-[640px]"
          data-qa-id="qa-id-seller-promotion-modal-content"
        >
          <ProductSellerPromotionInfoBannerHarmonisation
            offer={offer}
            product={product}
            title={dialogTitle}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
